import React from 'react';
import { useSelector } from 'react-redux';
import logo from '../../images/IE.png';
import './Header.css';

function Header() {
  const { quote: { code } } = useSelector((state) => state);
  return (
    <div className="d-flex justify-content-between align-items-center">
      <h3 id="quote-code">{`#${code}`}</h3>
      <div className="header-bar bg-blue" />
      <figure id="ie-logo">
        <img src={logo} alt="IE Logo" />
      </figure>
    </div>
  );
}

export default Header;
